import { render, staticRenderFns } from "./Wellness.vue?vue&type=template&id=e16cf7d4&"
import script from "./Wellness.vue?vue&type=script&lang=js&"
export * from "./Wellness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports